// import React, { useEffect, useState, useRef } from "react";

// import Header from "./Header";
// import "./Accomodation.css";
// import DatePicker from "react-multi-date-picker";
// import DateObject from "react-date-object";
// import moment from "moment";
// import { Navigate, useNavigate } from "react-router-dom";
// import "react-datepicker/dist/react-datepicker.css";
// import Navbar from "./Navbar";
// import Header from "./Header";
// // import AccomodationImages from "./AccomodationImages";

// const Accomodation = () => {
//   const navigate = useNavigate();
//   const userRole = localStorage.getItem("userRole");
//   const [selectedRooms, setSelectedRooms] = useState([]);
//   const datePickerRef = useRef();

//   let host = "http://13.203.79.3:3000";
//   const [startDate, setStartDate] = useState(new Date());
//   // const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   let localStoreNextDates = JSON.parse(localStorage.getItem("nextDates"));
//   if (localStoreNextDates == undefined) {
//     localStoreNextDates = [
//       new DateObject().add(0, "days"),
//       new DateObject().add(0, "days"),
//     ];
//   } else {
//     localStoreNextDates = [
//       new Date(localStoreNextDates[0]),
//       new Date(localStoreNextDates[1]),
//     ];
//   }
//   const [nextDates, setNextDates] = useState(localStoreNextDates);

//   const [roomsData, setData] = React.useState([]);
//   const [availableCalenderRoomsRes, setAvailableCalenderRoomsRes] =
//     React.useState([]);
//   // let selectedRooms = [];
//   let selectedRoomsTmp = [];
//   let selectedRoomDetails = {};

//   const roomBooking = (roomId) => {
//     const selectedRoom = roomsData.find((e) => e.room_id === roomId);
//     const isChecked = selectedRooms.some((room) => room.room_id === roomId);

//     setSelectedRooms((prevSelectedRooms) => {
//       const updatedRooms = isChecked
//         ? prevSelectedRooms.filter((room) => room.room_id !== roomId)
//         : [...prevSelectedRooms, selectedRoom];

//       const bookingDetailsData = {
//         locationId: document.getElementById("locationIds").value,
//         date: moment(startDate).format("yyyy-MM-DD"),
//         daysStay: document.getElementById("daysStay").value,
//         selectedRooms: updatedRooms,
//         selectedDateRange: nextDates,
//         fromDate: moment(nextDates[0]).format("yyyy-MM-DD"),
//         toDate: moment(nextDates[0]).format("yyyy-MM-DD"),
//       };

//       localStorage.setItem(
//         "bookingDetailsData",
//         JSON.stringify(bookingDetailsData)
//       );

//       return updatedRooms;
//     });
//   };

//   const handleCheckAvailability = async () => {
//     await checkAvailability();
//   };

//   const handleEnterKey = (event) => {
//     if (event.key === "Enter") {
//       if (document.activeElement.id === "daysStay") {
//         changeDaysStay();
//       } else {
//         handleCheckAvailability();
//       }
//     }
//   };

//   useEffect(() => {
//     checkAvailability();
//     populateAvailableRoomsInCalender();
//     // document.addEventListener("keydown", handleEnterKey);
//     // return () => {
//     //   document.removeEventListener("keydown", handleEnterKey);
//     // };
//   }, []);

//   const changeDaysStay = () => {
//     let nextDate = new Date();
//     let currentDayNo = nextDate.getDate();
//     let nextDates = [];
//     nextDates.push(new Date());
//     for (
//       let d = 1;
//       d < parseInt(document.getElementById("daysStay").value);
//       d++
//     ) {
//       nextDate = new Date();
//       nextDate.setDate(currentDayNo + d);
//       nextDates.push(nextDate);
//     }
//     setNextDates([
//       new DateObject().add(0, "days"),
//       new DateObject().add(
//         parseInt(document.getElementById("daysStay").value) - 1,
//         "days"
//       ),
//     ]);
//     //setStartDate([new DateObject().add(4, "days")]);

//     let tmpBookingDetailsData = JSON.parse(
//       localStorage.getItem("bookingDetailsData")
//     );
//     if (tmpBookingDetailsData == undefined || tmpBookingDetailsData === "{}") {
//       tmpBookingDetailsData = {};
//     }
//     tmpBookingDetailsData["daysStay"] =
//       document.getElementById("daysStay").value;
//     localStorage.setItem(
//       "bookingDetailsData",
//       JSON.stringify(tmpBookingDetailsData)
//     );
//     setData(roomsData);
//   };

//   const populateAvailableRoomsInCalender = (dateParam) => {
//     let tmpDates = [];
//     nextDates.map((d) => {
//       tmpDates.push(moment(d).format("yyyy-MM-DD"));
//     });
//     let dateQueryParam =
//       dateParam != undefined ? dateParam : tmpDates.toString();

//     let response = fetch(
//       host +
//         "/get-calendar-rooms?location=" +
//         document.getElementById("locationIds").value +
//         "&date=" +
//         dateQueryParam +
//         "&time=" +
//         Math.round(new Date().getTime() / 1000),
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     ).then((response) =>
//       response.json().then((availableCalenderRoomsRes) => {
//         setAvailableCalenderRoomsRes(availableCalenderRoomsRes);
//       })
//     );
//   };

//   const checkAvailability = async (selectedDates) => {
//     let response = await fetch(
//       host +
//         "/get-rooms?location=" +
//         document.getElementById("locationIds").value +
//         "&time=" +
//         Math.round(new Date().getTime() / 1000),
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     ).then((response) =>
//       response.json().then((roomsRes) => {
//         setData(roomsRes);
//         let tmpDates = [];
//         if (selectedDates !== undefined) {
//           try {
//             selectedDates.map((d) => {
//               tmpDates.push(moment(d).format("yyyy-MM-DD"));
//             });
//           } catch (e) {}
//         }
//         if (tmpDates.length == 0) {
//           nextDates.map((d) => {
//             tmpDates.push(moment(d).format("yyyy-MM-DD"));
//           });
//         }
//         response = fetch(
//           host +
//             "/get-booked-rooms?date=" +
//             tmpDates.toString() +
//             "&location=" +
//             document.getElementById("locationIds").value +
//             "&time=" +
//             Math.round(new Date().getTime() / 1000),
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         ).then((response) =>
//           response.json().then((res) => {
//             if (res != null) {
//               let tmpRoomsData = [];
//               roomsRes.forEach((element) => {
//                 let data = res.find((item) => {
//                   return item.room_id == element.room_id;
//                 });
//                 if (data != null) {
//                   element.roomStatus = "Not Available";
//                 } else {
//                   element.roomStatus = "Available";
//                 }
//                 tmpRoomsData.push(element);
//               });
//               setData(tmpRoomsData);
//             }
//           })
//         );
//       })
//     );
//   };

//   useEffect(() => {
//     checkAvailability();
//     populateAvailableRoomsInCalender();
//   }, []);

//   const renderDayContents = (date) => {
//     {
//       let month = date.month <= 9 ? "0" + date.month : date.month;
//       let calDay = date.day;
//       let dateDay =
//         date.year + "-" + month + "-" + (calDay <= 9 ? "0" + calDay : calDay);
//       const availableCount = availableCalenderRoomsRes[dateDay] || 0;
//       const notAvailableCount = roomsData.length - availableCount;

//       return {
//         children: (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               padding: "0 10px",
//               fontSize: "11px",
//             }}
//           >
//             <div style={{ fontSize: "15px", height: "20px" }}>{date.day}</div>

//             <div
//               className="callend_available_green"
//               style={{ textAlign: "center" }}
//             >
//               {availableCount > 0 ? `${availableCount} Ava` : ""}
//               <br />
//               {/* {availableCount > 0 && notAvailableCount > 0 ? "+" : ""} */}
//             </div>
//             <div
//               className="callend_available_red"
//               style={{ textAlign: "center" }}
//             >
//               {notAvailableCount > 0 ? `${notAvailableCount} booked` : ""}
//             </div>
//           </div>
//         ),
//       };
//     }
//   };

//   const repopulateCalendarRoomsData = (date) => {
//     let toDate = new Date(date);
//     toDate.setDate(
//       toDate.getDate() + parseInt(document.getElementById("daysStay").value - 1)
//     );

//     let tmpDates = [new Date(date), toDate];

//     //setStartDate(tmpDates);
//     setNextDates(tmpDates);
//     let tmpBookingDetailsData = JSON.parse(
//       localStorage.getItem("bookingDetailsData")
//     );
//     if (tmpBookingDetailsData == undefined || tmpBookingDetailsData === "{}") {
//       tmpBookingDetailsData = {};
//     }
//     localStorage.setItem(
//       "bookingDetailsData",
//       JSON.stringify(tmpBookingDetailsData)
//     );
//     populateAvailableRoomsInCalender(moment(toDate).format("yyyy-MM-DD"));
//     localStorage.setItem("nextDates", JSON.stringify(tmpDates));
//     // datePickerOnclose();
//     checkAvailability(tmpDates);
//     // datePickerRef.current.closeCalendar();
//   };
//   //prevent onclose calendar actions and populating selected date range
//   const datePickerOnclose = () => {
//     let localStoreNextDates = JSON.parse(localStorage.getItem("nextDates"));
//     if (localStoreNextDates != undefined) {
//       localStoreNextDates = [
//         new Date(localStoreNextDates[0]),
//         new Date(localStoreNextDates[1]),
//       ];
//       setNextDates(localStoreNextDates);
//     }
//   };
//   const onChangeLocation = () => {
//     populateAvailableRoomsInCalender(moment(nextDates[0]).format("yyyy-MM-DD"));
//     checkAvailability();
//   };

//   //[{ "accommodation_type": "Loghut", "room_number": "Loghut-3 (First floor)", "price": "Rs. 1500/- each Room", "persons": "2", "additional_chargers": "Note: For an extra person, there is an additional charge of Rs. 100/- (only one person).", "img": "http://www.vanadarshani.in/images/accomodation/talakona/talakona-room-booking-online-2.gif" }, { "accommodation_type": "Loghut", "room_number": "Loghut-4 (First floor)", "price": "Rs. 1500/- each Room", "persons": "2", "additional_chargers": "Note: For an extra person, there is an additional charge of Rs. 100/- (only one person).", "img": "http://www.vanadarshani.in/images/accomodation/talakona/talakona-room-booking-online-2.gif" }, { "accommodation_type": "Loghut", "room_number": "Loghut-5 (First floor)", "price": "Rs. 1250/- each Room", "persons": "2", "additional_chargers": "Note: For an extra person, there is an additional charge of Rs. 100/- (only one person).", "img": "http://www.vanadarshani.in/images/accomodation/talakona/talakona-room-booking-online-2.gif" }, { "accommodation_type": "Loghut", "room_number": "Loghut-5 (First floor)", "price": "Rs. 1250/- each Room", "persons": "2", "additional_chargers": "Note: For an extra person, there is an additional charge of Rs. 100/- (only one person).", "img": "http://www.vanadarshani.in/images/accomodation/talakona/talakona-room-booking-online-2.gif" }, { "accommodation_type": "Dormitory", "room_number": "Dormitory-1", "price": "Rs. 5000/- each Room", "persons": "10", "additional_chargers": "Note: For an extra person, there is an additional charge of Rs. 100/- (only one person).", "img": "http://www.vanadarshani.in/images/i1.JPG" }, { "accommodation_type": "Dormitory", "room_number": "Dormitory-1", "price": "Rs. 5000/- each Room", "persons": "10", "additional_chargers": "Note: For an extra person, there is an additional charge of Rs. 100/- (only one person).", "img": "http://www.vanadarshani.in/images/i1.JPG" }]
//   return (
//     <div>
//       {/* <Navbar /> */}
//       <Header />

//       <div className="container">
//         <div className="row">
//           <div className="col-lg-2"></div>
//           <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 content_back">
//             <h1
//               className="text-center"
//               style={{ fontSize: "25px", color: "green" }}
//             >
//               Venues
//             </h1>
//             <p>
//               Kalyana Mandapam, Functional Halls, and Ground are available at
//               Visakhapatnam
//             </p>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Select Location <span className="required">*</span>
//                 </label>
//                 <select
//                   id="locationIds"
//                   onChange={onChangeLocation}
//                   onKeyDown={handleEnterKey}
//                 >
//                   <option value="">Select Location</option>
//                   <option value="1">Gurajada Kalakshetram</option>
//                   <option value="2">MGM Lawn</option>
//                   <option value="3">Chinnamusidivada</option>
//                   <option value="4">Children's Arena</option>
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>
//                   Select Room <span className="required">*</span>
//                 </label>
//                 <select>
//                   <option value="">Select Type</option>
//                   {[
//                     ...new Set(
//                       roomsData.map((room) => room.accommodation_type)
//                     ),
//                   ].map((type, index) => (
//                     <option key={index} value={type}>
//                       {type}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="form-group">
//                 <label>
//                   Select Room <span className="required">*</span>
//                 </label>
//                 <select>
//                   <option value="">Select Room</option>
//                   {roomsData.map((room) => (
//                     <option key={room.room_id} value={room.room_id}>
//                       {room.room_name} - Rs. {room.amount}/-
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>
//                 Select Dates <span className="required">*</span>
//               </label>
//               <DatePicker
//                 ref={datePickerRef}
//                 // onClose={() => {
//                 //   datePickerOnclose();
//                 // }}
//                 numberOfMonths={2}
//                 range
//                 value={nextDates}
//                 onChange={(date) => {
//                   repopulateCalendarRoomsData(date);
//                 }}
//                 mapDays={({ date }) => renderDayContents(date)}
//                 onMonthChange={(date) => {
//                   repopulateCalendarRoomsData(date);
//                 }}
//                 minDate={moment(new Date()).format("yyyy-MM-DD")}
//                 onKeyDown={handleEnterKey}
//                 editable={false} // Add this line to disable editing
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Accomodation;

// import React, { useEffect, useState, useRef } from "react";

// // import Header from "./Header";
// import "./Accomodation.css";
// import DatePicker from "react-multi-date-picker";
// import DateObject from "react-date-object";
// import moment from "moment";
// import { Navigate, useNavigate } from "react-router-dom";
// import "react-datepicker/dist/react-datepicker.css";
// import Navbar from "./Navbar";
// import Header from "./Header";
// // import AccomodationImages from "./AccomodationImages
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";

// const Accomodation = () => {
//   const navigate = useNavigate();
//   const userRole = localStorage.getItem("userRole");
//   const [selectedRooms, setSelectedRooms] = useState([]);
//   const datePickerRef = useRef();

//   let host = "http://13.203.79.3:3000";
//   const [startDate, setStartDate] = useState(new Date());
//   let localStoreNextDates = JSON.parse(localStorage.getItem("nextDates"));
//   if (localStoreNextDates == undefined) {
//     localStoreNextDates = [
//       new DateObject().add(0, "days"),
//       new DateObject().add(0, "days"),
//     ];
//   } else {
//     localStoreNextDates = [
//       new Date(localStoreNextDates[0]),
//       new Date(localStoreNextDates[1]),
//     ];
//   }
//   const [nextDates, setNextDates] = useState(localStoreNextDates);

//   const [roomsData, setData] = React.useState([]);
//   const [availableCalenderRoomsRes, setAvailableCalenderRoomsRes] =
//     React.useState([]);
//   // let selectedRooms = [];
//   let selectedRoomsTmp = [];
//   let selectedRoomDetails = {};

//   const roomBooking = (roomId) => {
//     const selectedRoom = roomsData.find((e) => e.room_id === roomId);
//     const isChecked = selectedRooms.some((room) => room.room_id === roomId);

//     setSelectedRooms((prevSelectedRooms) => {
//       const updatedRooms = isChecked
//         ? prevSelectedRooms.filter((room) => room.room_id !== roomId)
//         : [...prevSelectedRooms, selectedRoom];

//       const bookingDetailsData = {
//         locationId: document.getElementById("locationIds").value,
//         date: moment(startDate).format("yyyy-MM-DD"),
//         daysStay: document.getElementById("daysStay").value,
//         selectedRooms: updatedRooms,
//         selectedDateRange: nextDates,
//         fromDate: moment(nextDates[0]).format("yyyy-MM-DD"),
//         toDate: moment(nextDates[0]).format("yyyy-MM-DD"),
//       };

//       localStorage.setItem(
//         "bookingDetailsData",
//         JSON.stringify(bookingDetailsData)
//       );

//       return updatedRooms;
//     });
//   };

//   const handleCheckAvailability = async () => {
//     await checkAvailability();
//   };

//   const handleEnterKey = (event) => {
//     if (event.key === "Enter") {
//       if (document.activeElement.id === "daysStay") {
//         changeDaysStay();
//       } else {
//         handleCheckAvailability();
//       }
//     }
//   };

//   useEffect(() => {
//     checkAvailability();
//     populateAvailableRoomsInCalender();
//     document.addEventListener("keydown", handleEnterKey);
//     return () => {
//       document.removeEventListener("keydown", handleEnterKey);
//     };
//   }, []);

//   const changeDaysStay = () => {
//     let nextDate = new Date();
//     let currentDayNo = nextDate.getDate();
//     let nextDates = [];
//     nextDates.push(new Date());
//     for (
//       let d = 1;
//       d < parseInt(document.getElementById("daysStay").value);
//       d++
//     ) {
//       nextDate = new Date();
//       nextDate.setDate(currentDayNo + d);
//       nextDates.push(nextDate);
//     }
//     setNextDates([
//       new DateObject().add(0, "days"),
//       new DateObject().add(
//         parseInt(document.getElementById("daysStay").value) - 1,
//         "days"
//       ),
//     ]);
//     //setStartDate([new DateObject().add(4, "days")]);

//     let tmpBookingDetailsData = JSON.parse(
//       localStorage.getItem("bookingDetailsData")
//     );
//     if (tmpBookingDetailsData == undefined || tmpBookingDetailsData === "{}") {
//       tmpBookingDetailsData = {};
//     }
//     tmpBookingDetailsData["daysStay"] =
//       document.getElementById("daysStay").value;
//     localStorage.setItem(
//       "bookingDetailsData",
//       JSON.stringify(tmpBookingDetailsData)
//     );
//     setData(roomsData);
//   };

//   const populateAvailableRoomsInCalender = (dateParam) => {
//     let tmpDates = [];
//     nextDates.map((d) => {
//       tmpDates.push(moment(d).format("yyyy-MM-DD"));
//     });
//     let dateQueryParam =
//       dateParam != undefined ? dateParam : tmpDates.toString();

//     let response = fetch(
//       host +
//         "/get-calendar-rooms?location=" +
//         document.getElementById("locationIds").value +
//         "&date=" +
//         dateQueryParam +
//         "&time=" +
//         Math.round(new Date().getTime() / 1000),
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     ).then((response) =>
//       response.json().then((availableCalenderRoomsRes) => {
//         setAvailableCalenderRoomsRes(availableCalenderRoomsRes);
//       })
//     );
//   };

//   const checkAvailability = async (selectedDates) => {
//     let response = await fetch(
//       host +
//         "/get-rooms?location=" +
//         document.getElementById("locationIds").value +
//         "&time=" +
//         Math.round(new Date().getTime() / 1000),
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     ).then((response) =>
//       response.json().then((roomsRes) => {
//         setData(roomsRes);
//         let tmpDates = [];
//         if (selectedDates !== undefined) {
//           try {
//             selectedDates.map((d) => {
//               tmpDates.push(moment(d).format("yyyy-MM-DD"));
//             });
//           } catch (e) {}
//         }
//         if (tmpDates.length == 0) {
//           nextDates.map((d) => {
//             tmpDates.push(moment(d).format("yyyy-MM-DD"));
//           });
//         }
//         response = fetch(
//           host +
//             "/get-booked-rooms?date=" +
//             tmpDates.toString() +
//             "&location=" +
//             document.getElementById("locationIds").value +
//             "&time=" +
//             Math.round(new Date().getTime() / 1000),
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         ).then((response) =>
//           response.json().then((res) => {
//             if (res != null) {
//               let tmpRoomsData = [];
//               roomsRes.forEach((element) => {
//                 let data = res.find((item) => {
//                   return item.room_id == element.room_id;
//                 });
//                 if (data != null) {
//                   element.roomStatus = "Not Available";
//                 } else {
//                   element.roomStatus = "Available";
//                 }
//                 tmpRoomsData.push(element);
//               });
//               setData(tmpRoomsData);
//             }
//           })
//         );
//       })
//     );
//   };

//   useEffect(() => {
//     checkAvailability();
//     populateAvailableRoomsInCalender();
//   }, []);

//   const renderDayContents = (date) => {
//     {
//       let month = date.month <= 9 ? "0" + date.month : date.month;
//       let calDay = date.day;
//       let dateDay =
//         date.year + "-" + month + "-" + (calDay <= 9 ? "0" + calDay : calDay);
//       const availableCount = availableCalenderRoomsRes[dateDay] || 0;
//       const notAvailableCount = roomsData.length - availableCount;

//       return {
//         children: (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               padding: "0 10px",
//               fontSize: "11px",
//             }}
//           >
//             <div style={{ fontSize: "15px", height: "20px" }}>{date.day}</div>

//             <div
//               className="callend_available_green"
//               style={{ textAlign: "center" }}
//             >
//               {availableCount > 0 ? `${availableCount} Ava` : ""}
//               <br />
//               {/* {availableCount > 0 && notAvailableCount > 0 ? "+" : ""} */}
//             </div>
//             <div
//               className="callend_available_red"
//               style={{ textAlign: "center" }}
//             >
//               {notAvailableCount > 0 ? `${notAvailableCount} booked` : ""}
//             </div>
//           </div>
//         ),
//       };
//     }
//   };

//   const repopulateCalendarRoomsData = (date) => {
//     let toDate = new Date(date);
//     // toDate.setDate(
//     //   toDate.getDate() + parseInt(document.getElementById("daysStay").value - 1)
//     // );

//     let tmpDates = [new Date(date), toDate];

//     //setStartDate(tmpDates);
//     setNextDates(tmpDates);
//     let tmpBookingDetailsData = JSON.parse(
//       localStorage.getItem("bookingDetailsData")
//     );
//     if (tmpBookingDetailsData == undefined || tmpBookingDetailsData === "{}") {
//       tmpBookingDetailsData = {};
//     }
//     localStorage.setItem(
//       "bookingDetailsData",
//       JSON.stringify(tmpBookingDetailsData)
//     );
//     populateAvailableRoomsInCalender(moment(toDate).format("yyyy-MM-DD"));
//     localStorage.setItem("nextDates", JSON.stringify(tmpDates));
//     // datePickerOnclose();
//     checkAvailability(tmpDates);
//     // datePickerRef.current.closeCalendar();
//   };
//   //prevent onclose calendar actions and populating selected date range
//   const datePickerOnclose = () => {
//     let localStoreNextDates = JSON.parse(localStorage.getItem("nextDates"));
//     if (localStoreNextDates != undefined) {
//       localStoreNextDates = [
//         new Date(localStoreNextDates[0]),
//         new Date(localStoreNextDates[1]),
//       ];
//       setNextDates(localStoreNextDates);
//     }
//   };
//   const onChangeLocation = () => {
//     populateAvailableRoomsInCalender(moment(nextDates[0]).format("yyyy-MM-DD"));
//     checkAvailability();
//   };

//   return (
//     <div>

//       <Header />

//       <div className="container">
//         <div className="row">
//           <div className="col-lg-2"></div>
//           <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 content_back">
//             <h1
//               className="text-center"
//               style={{ fontSize: "25px", color: "green" }}
//             >
//               Venues
//             </h1>
//             <p>
//               Kalyana Mandapam, Functional Halls, and Ground are available at
//               Visakhapatnam
//             </p>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Select Location <span className="required">*</span>
//                 </label>
//                 <select
//                   id="locationIds"
//                   onChange={onChangeLocation}
//                   onKeyDown={handleEnterKey}
//                 >
//                   <option value="">Select Location</option>
//                   <option value="1">Gurajada Kalakshetram</option>
//                   <option value="2">MGM Lawn</option>
//                   <option value="3">Chinnamusidivada</option>
//                   <option value="4">Children's Arena</option>
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>
//                   Select Room <span className="required">*</span>
//                 </label>
//                 <select>
//                   <option value="">Select Type</option>
//                   {[
//                     ...new Set(
//                       roomsData.map((room) => room.accommodation_type)
//                     ),
//                   ].map((type, index) => (
//                     <option key={index} value={type}>
//                       {type}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="form-group">
//                 <label>
//                   Select Room <span className="required">*</span>
//                 </label>
//                 <select>
//                   <option value="">Select Room</option>
//                   {roomsData.map((room) => (
//                     <option key={room.room_id} value={room.room_id}>
//                       {room.room_name} - Rs. {room.amount}/-
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>
//                 Select Dates <span className="required">*</span>
//               </label>
//                {/* <DatePicker
//                                    ref={datePickerRef}
//                                    onClose={() => {
//                                      datePickerOnclose();
//                                    }}
//                                    numberOfMonths={2}
//                                    range
//                                    value={nextDates}
//                                    onChange={(date) => {
//                                      repopulateCalendarRoomsData(date);
//                                    }}
//                                    mapDays={({ date }) => renderDayContents(date)}
//                                    onMonthChange={(date) => {
//                                      repopulateCalendarRoomsData(date);
//                                    }}
//                                    minDate={moment(new Date()).format("yyyy-MM-DD")}
//                                    onKeyDown={handleEnterKey}
//                                    editable={false} // Add this line to disable editing
//                                  /> */}

//                                  <Calendar
//           selectRange
//           value={nextDates}
//           // onChange={handleDateChange}
//           minDate={new Date()}
//           numberOfMonths={2}

//                                    onChange={(date) => {
//                                      repopulateCalendarRoomsData(date);
//                                    }}
//           showDoubleView={true}

//         />
//             </div>
//           </div>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default Accomodation;

import React, { useEffect, useState } from "react";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Accomodation.css";
import Header from "./Header";
import host from "../config";
const Accommodation = () => {
  // const host = "https://api.vmrdarental.com";
  // let host = "http://13.203.181.236:3000";
  const [locations, setLocations] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [calendarDates, setCalendarDates] = useState([new Date(), new Date()]);
  const [purposes, setPurposes] = useState([]); // Keep purposes in state
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [amount, setAmount] = useState(0);

  // Fetch locations on component mount
  useEffect(() => {
    setLocations([
      { id: "1", name: "Gurajada Kalakshetram" },
      { id: "2", name: "MGM Lawn" },
      { id: "3", name: "Chinnamusidivada" },
      { id: "4", name: "Children's Arena" },
    ]);
  }, []);

  // Fetch room types based on selected location
  useEffect(() => {
    if (selectedLocation) {
      fetchRoomTypes();
    }
  }, [selectedLocation]);

  // Fetch rooms based on location and room type
  useEffect(() => {
    if (selectedLocation && selectedRoomType) {
      fetchRooms();
    }
  }, [selectedLocation, selectedRoomType]);

  // Fetch purposes when a room is selected
  useEffect(() => {
    if (selectedRoom) {
      fetchPurposes();
    }
  }, [selectedRoom]);

  // Fetch room types from the `/get-rooms` API
  const fetchRoomTypes = async () => {
    try {
      const response = await fetch(
        `${host}/get-rooms?location=${selectedLocation}`
      );
      const data = await response.json();
      const types = [...new Set(data.map((room) => room.accommodation_type))];
      setRoomTypes(types);
      setRooms([]); // Reset rooms when location changes
      setPurposes([]); // Reset purposes when location changes
    } catch (error) {
      console.error("Error fetching room types:", error);
    }
  };

  // Fetch rooms from the `/get-rooms` API
  const fetchRooms = async () => {
    try {
      const response = await fetch(
        `${host}/get-rooms?location=${selectedLocation}&type=${selectedRoomType}`
      );
      const data = await response.json();
      setRooms(data);
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  // Fetch purposes and amounts from the selected room data
  const fetchPurposes = () => {
    const room = rooms.find((room) => room.room_id === selectedRoom);
    if (room && room.rooms) {
      // Check if the room object has the `rooms` array, then extract purposes
      const purposes = room.rooms.map((roomDetails) => roomDetails.purpose);
      setPurposes(purposes);
      setAmount(room.amount); // Set the initial amount
    } else {
      // Reset purposes if no room is found or no purposes are available
      setPurposes([]);
    }
  };

  // Handle calendar date change and fetch room availability
  const handleCalendarChange = async (dates) => {
    setCalendarDates(dates);
    if (selectedLocation) {
      const formattedDates = dates.map((date) =>
        moment(date).format("YYYY-MM-DD")
      );
      try {
        const response = await fetch(
          `${host}/get-calendar-rooms?location=${selectedLocation}&date=${formattedDates.join(
            ","
          )}`
        );
        const data = await response.json();
        console.log("Room availability:", data);
      } catch (error) {
        console.error("Error fetching calendar room data:", error);
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="container">
        <h1
          className="text-center"
          style={{ fontSize: "25px", color: "green" }}
        >
          Venues
        </h1>

        {/* Location Dropdown */}
        <div className="form-group">
          <label>Select Location</label>
          <select
            id="locationIds"
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="">Select Location</option>
            {locations.map((location) => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>
        </div>

        {/* Room Type Dropdown */}
        <div className="form-group">
          <label>Select Room Type</label>
          <select
            value={selectedRoomType}
            onChange={(e) => setSelectedRoomType(e.target.value)}
          >
            <option value="">Select Type</option>
            {roomTypes.map((accommodation_type, index) => (
              <option key={index} value={accommodation_type}>
                {accommodation_type}
              </option>
            ))}
          </select>
        </div>

        {/* Room Dropdown */}
        <div className="form-group">
          <label>Select Room</label>
          <select
            value={selectedRoom}
            onChange={(e) => setSelectedRoom(e.target.value)}
          >
            <option value="">Select Room</option>
            {rooms
              .map((room) => room.room_id) // Use room_id for unique selection
              .map((roomId, index) => {
                const room = rooms.find((r) => r.room_id === roomId);
                return (
                  <option key={index} value={roomId}>
                    {room?.room_name}
                  </option>
                );
              })}
          </select>
        </div>

        {/* Calendar */}
        <div className="form-group">
          <label>Select Dates</label>
          <Calendar
            selectRange
            value={calendarDates}
            onChange={handleCalendarChange}
            minDate={new Date()}
            showDoubleView={true}
          />
        </div>

        {/* Purpose Dropdown */}
        <div className="form-group">
          <label>Select Purpose</label>
          <select
            value={selectedPurpose}
            onChange={(e) => setSelectedPurpose(e.target.value)}
          >
            <option value="">Select Purpose</option>
            {purposes.length > 0 ? (
              purposes.map((purpose, index) => (
                <option key={index} value={purpose}>
                  {purpose}
                </option>
              ))
            ) : (
              <option value="">No purposes available</option>
            )}
          </select>
        </div>

        {/* Amount Display */}
        <div className="form-group">
          <label>Total Amount:</label>
          <p>{amount ? `₹${amount}` : "Select a room to see the amount"}</p>
        </div>
      </div>
    </div>
  );
};

export default Accommodation;
